import PropTypes from 'prop-types';

export const FlipcardSideTypes = {
  htmlContent: PropTypes.string,
  imageUrl: PropTypes.string,
  instruction: PropTypes.string,
  side: PropTypes.oneOf(['back', 'front']),
  flipOver: PropTypes.func,
  setIsOver: PropTypes.func,
};

export const FlipcardTypes = {
  altContentImageUrl: PropTypes.string,
  back: PropTypes.string,
  contentImageUrl: PropTypes.string,
  flipcardId: PropTypes.number,
  front: PropTypes.string,
  instruction: PropTypes.string,
};
